import axios from 'lib/axios'

export const getCustomCategory = () => {
  return axios.get('admin/custom')
}

export const postCustomCategory = (data) => {
  return axios.post('admin/custom', data)
}

export const editCustomCategory = ({ id, data }) => {
  return axios.put(`admin/custom/${id}`, data)
}

export const deleteCustomCategory = ({ id }) => {
  return axios.delete(`admin/custom/${id}`)
}
